import { render, staticRenderFns } from "./UserAccount.vue?vue&type=template&id=5594bd62&scoped=true&"
import script from "./UserAccount.vue?vue&type=script&lang=js&"
export * from "./UserAccount.vue?vue&type=script&lang=js&"
import style0 from "./index.scss?vue&type=style&index=0&id=5594bd62&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5594bd62",
  null
  
)

export default component.exports